import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { filter } from 'rxjs/operators';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectConditionDO } from '../../../../../../system/system-dtos';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';

@Component({
  selector: 'app-form-field-condition',
  templateUrl: './condition-form-field.component.html',
  standalone: false,
})
export class ConditionFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  conditions: SelectConditionDO[] = [];

  conditionData: any;

  selected: SelectConditionDO;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  conditionId: any;

  constructor(
    private blastService: BlastV2Service,
    private entityGroupService: EntityGroupDetailsService
  ) {
    super();
  }

  ngOnInit() {
    this.blastService
      .getCollectionObservable('promotioncondition')
      .pipe(filter((d) => !!d))
      .subscribe((list) => {
        this.conditions = list.sort((a: SelectConditionDO, b: SelectConditionDO) => {
          if (a.displayOrder > b.displayOrder) {
            return 1;
          }
          if (a.displayOrder < b.displayOrder) {
            return -1;
          }
          return 0;
        });
        if (this.data !== undefined) {
          this.onConditionChange(
            this.data.condition ? this.data.condition : this.data,
            new MatOptionSelectionChange(null, true),
            this.rowData.condition ? this.rowData.condition.conditionData : this.rowData.conditionData
          );
        }
      });
  }

  onConditionChange(condition: SelectConditionDO, $event: MatOptionSelectionChange, conditionData) {
    if (!$event.isUserInput || (this.selected && condition.id === this.selected.id)) {
      return;
    }
    this.selected = condition;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.conditionId = condition ? condition.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        row.columns.forEach((column) => {
          column.fields.forEach((f) => {
            this.fields.push(f);
          });
        });
      });
    }

    if (
      conditionData !== undefined &&
      !(Object.keys(conditionData).length === 0 && conditionData.constructor === Object)
    ) {
      this.conditionData = conditionData;
    } else {
      this.conditionData = condition.dataTemplate;
    }
    this.selectedFieldConfig = {
      name: 'conditionData',
      label: 'Criteria',
      type: 'criteria',
      strippedRows: true,
    } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
    this.entityGroupService.isotopeLayout.next();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}
}
